import { createTheme } from "@material-ui/core/styles";

const theme = createTheme();

const darkTheme = {
  palette: {
    type: "dark",
    primary: {
      main: "rgb(6,11,17,0.8)"
    },
    secondary: {
      main: "#0E1011",
      darkGrey: "#111121"
    },

    text: {
      highlight: "#5D5FFF",
      primary: "#CEDFFF",
      tertiary: "#8EA2C7",
      white: "#ffffff",
    },
    background: {
      paper: "#000"
    },
    contrastThreshold: 3,
    tonalOffset: 0.2
  },
  typography: {
    fontFamily: ["EudoxusSans"].join(","),
    h1: {
      fontSize: "3rem",
      fontFamily: "EudoxusSans",
      fontWeight: 600,
      lineHeight: "auto",
      [theme.breakpoints.down("sm")]: {
        fontSize: "2rem"
      }
    },
    h2: {
      fontSize: "3rem",
      fontFamily: "EudoxusSans",
      fontWeight: 800,
      letterSpacing: "1px",
      [theme.breakpoints.down("sm")]: {
        fontSize: "2.50rem"
      }
    },
    h3: {
      fontSize: "2rem",
      fontWeight: 500,
      fontFamily: "Poppins",
      lineHeight: "auto",
      letterSpacing: "auto",
      [theme.breakpoints.down("sm")]: {
        fontSize: "2rem"
      }
    },
    h4: {
      fontSize: "1.75rem",
      fontWeight: 400,
      fontFamily: "EudoxusSans",
      lineHeight: "auto",
      letterSpacing: "auto",
      [theme.breakpoints.down("sm")]: {
        fontSize: "1.5rem"
      }
    },
    h5: {
      fontSize: "1.5rem",
      fontWeight: 600,
      fontFamily: "EudoxusSans",
      lineHeight: "auto",
      letterSpacing: "auto",
      [theme.breakpoints.down("sm")]: {
        fontSize: "1.25rem"
      }
    },
    h6: {
      fontSize: "1rem",
      fontWeight: 100,
      fontFamily: "Poppins",
      lineHeight: 1.6,
      // letterSpacing: "0.6px",
      letterSpacing: "auto",
      // wordSpacing: "2px"
    },
    secondaryTitle: {
      fontSize: "2rem",
      fontFamily: "EudoxusSans",
      fontWeight: 600,
      letterSpacing: "1px",
      margin: "0rem",
      padding: "5rem 0rem",
      "-webkit-text-fill-color":
        "transparent" /*Will override color (regardless of order) */,
      " -webkit-text-stroke": " 1px #63718A",
      [theme.breakpoints.down("sm")]: {
        fontSize: "2rem"
      }
    },
    button: {
      fontSize: "0.875rem",
      fontWeight: 500,
      lineHeight: 1.75,
      letterSpacing: "0.02857em",
      textTransform: "unset !important",
      [theme.breakpoints.down("sm")]: {
        fontSize: "0.5rem"
      }
    }
  }
};

export { darkTheme, createTheme };
